import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  root: {
    transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.1)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
  },
});

const ToolTippedIconButton = ({ iconButtonProps = {}, tooltipProps = {}, disabled = false, children }) => {
  const { classes } = useStyles();
  const { className, ...otherIconButtonProps } = iconButtonProps;
  const combinedClassName = `${classes.root} ${className || ''}`;

  return disabled ? (
    <IconButton className={combinedClassName} {...otherIconButtonProps} disabled={disabled}>
      {children}
    </IconButton>
  ) : (
    <Tooltip {...tooltipProps}>
      <IconButton className={combinedClassName} {...otherIconButtonProps} disabled={disabled}>
        {children}
      </IconButton>
    </Tooltip>
  );
};

ToolTippedIconButton.propTypes = {
  iconButtonProps: PropTypes.shape({ ...IconButton.propTypes }),
  tooltipProps: PropTypes.shape({ ...Tooltip.propTypes }),
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default ToolTippedIconButton;
